import Type from './Type';
export function isICard(node) {
    return node.type === Type.Card;
}
export default isICard;    //# sourceMappingURL=isICard.js.map
